import React, {useCallback, useEffect, useState} from 'react';
import {Col, Container, Row} from 'reactstrap';
import classNames from 'classnames';
import {Location} from '@reach/router';
import queryString from 'query-string';
import {subscribeToCampaign} from 'react-controlled-ab/datalayers/vwo';

import {usePhaseState} from 'funnel-schedule/phase-context';
import useBalanceText from 'utils/useBalanceText';

import PageMeta from 'components/PageMeta';
import Header from 'components/Elements/Header';
import SectionCL from 'components/ComponentLibrary/SectionCL';
import CountdownTimer from 'components/Elements/CountdownTimer';
import Video from 'components/Video';
import IconListCL from 'components/ComponentLibrary/IconListCL/IconListCL';
import {TestimonialBubble} from 'components/Testimonial';
import OptinModal, {OptinModalTrigger} from 'components/OptinModal';
import ExitModal from 'components/ComponentLibrary/ExitModal';
import Footer from 'components/Elements/Footer';

export default function Index(props) {
  return (
    <Location>
      {({location, navigate}) => <MasterClassIndex location={location} navigate={navigate} {...props} />}
    </Location>
  );
}
function MasterClassIndex({
  location = {},
  noShare = false,
  noFixedVideo = false,
  noExitIntent = false,
  slug = 'masterclass',
  navigate,
  variant = 'default',
  ...props
}) {
  const qs = typeof window !== 'undefined' ? queryString.parse(window.location.search) : {};
  const navigateWatch = useCallback(() => navigate('/masterclass/watch/'), []);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const pathName = window.location.pathname;
      const pathRegex = new RegExp(`\/${slug}\/`, 'g');
      if (!pathName.match(pathRegex)) {
        navigate(`/${slug}/` + location.search);
      }
    }
  }, []);

  const videoUrl = 'https://www.youtube.com/watch?v=OD4CXU-7MYE';
  const videoThumbUrl = 'https://cdn.foodrevolution.org/tt2/videothumb/tt2-landing-dynamicthumbnail-20230626-1.gif';
  const videoButton = true;

  const {
    phases: {
      default: defaultSchedule = {
        phase: 'before',
        launchStart: '',
        launchEnd: '',
        launchTitle: ''
      }
    }
  } = usePhaseState();

  const launchEnd = new Date(defaultSchedule.launchEnd).getTime();

  const [headingControl, setheadingControl] = useState(props.headingControl || 'control');
  useEffect(() => {
    subscribeToCampaign((variantIndex) => {
      switch (variantIndex) {
        case 1:
          setheadingControl('v1');
          break;
        case 2:
          setheadingControl('v2');
          break;
      }
    }, 1322);
  }, []);

  const [videoControl, setvideoControl] = useState(props.videoControl || 'control');
  useEffect(() => {
    subscribeToCampaign((variantIndex) => {
      switch (variantIndex) {
        case 1:
          setvideoControl('v1');
          break;
      }
    }, 1323);
  }, []);

  function LandingTimer({className = null, ...props}) {
    return (
      <div className={classNames(`section-countdown countdown-${props.light ? 'light' : 'dark'}`, className)}>
        <h5 className="timer-heading mt-0 mb-2">{defaultSchedule.launchTitle} ends in:</h5>
        <CountdownTimer time={launchEnd} />
      </div>
    );
  }

  function ModalTrigger({className = 'mb-4'}) {
    return <OptinModalTrigger className={className}>Reserve My Spot</OptinModalTrigger>;
  }

  function Logo({className = null, src = 'https://cdn.foodrevolution.org/tt2/tt2m-logo-2024.svg'}) {
    return <img className={className} src={src} alt="Tackling Type 2 Masterclass logo" style={{maxHeight: '100px'}} />;
  }

  useBalanceText();
  return (
    <div className="page page-nosocial d-flex flex-column">
      <PageMeta />
      <div className="page-content">
        <Header bgColor="white" textColor="black" logoCentered adLockup={variant === 'ad' ? true : false} />
        <SectionCL
          id="landing-header-v1"
          imgUrl="https://cdn.foodrevolution.org/tt2/images/1253414265.jpg"
          color="black"
          innerClass={classNames(`my-auto`, videoControl === 'control' && `p-0`)}
          className={classNames(`d-flex`, `flex-column`, `background-fixed`)}
          order="first"
          angle="none"
        >
          <Container>
            <Row>
              <Col>
                <div
                  className={classNames(
                    `background-white`,
                    `rounded`,
                    `box-shadow-black-50`,
                    `p-4`,
                    `p-lg-5`,
                    `text-center`,
                    videoControl === 'control' && `optin-box`
                  )}
                >
                  <p>
                    <b>
                      <i>Now Playing For A Limited Time!</i>
                    </b>
                  </p>
                  {
                    {
                      control: (
                        <>
                          <h2 className="section-heading mb-3">
                            Conventional Wisdom Says That Type 2 Diabetes is a Progressive and Irreversible Disease.
                          </h2>
                          <h3 className="mt-0 mb-3">Here’s what they’re NOT telling you.</h3>
                          <h5 className="section-heading text-400 text-center mb-4">
                            Join world-renowned anti-diabetes expert Brenda Davis, RD, to discover the truth — and how
                            to enjoy balanced blood sugar, peace of mind, and optimal health. With food!
                          </h5>
                        </>
                      ),
                      v1: (
                        <>
                          <h2 className="section-heading mb-3">
                            Find out why the conventional approach can cause the disease to get WORSE.
                          </h2>
                          <h5 className="section-heading text-400 text-center mb-4">
                            Join world-renowned diabetes expert Brenda Davis, RD, to discover the truth. You’ll learn
                            how to enjoy balanced blood sugar, peace of mind, and optimal health. With food!
                          </h5>
                        </>
                      ),
                      v2: (
                        <>
                          <h2 className="section-heading mb-3">
                            Find out if you can actually eat more and lower your A1C without medication or restrictive
                            dieting.
                          </h2>
                          <h5 className="section-heading text-400 text-center mb-4">
                            Join world-renowned diabetes expert Brenda Davis, RD, to discover the truth. You’ll learn
                            how to enjoy balanced blood sugar, peace of mind, and optimal health. With food!
                          </h5>
                        </>
                      )
                    }[headingControl]
                  }
                  <ModalTrigger />
                </div>
              </Col>
            </Row>
          </Container>
        </SectionCL>
        {videoControl === 'control' && (
          <SectionCL
            id="landing-video-v1"
            color="white"
            className={classNames(`text-center`, `section-triangle-offset-top-none`)}
            angle="both"
          >
            <Container>
              <Row className="justify-content-center">
                <Col lg="10" className="video-col px-0 px-sm-3">
                  <Video url={videoUrl} thumbnail={videoThumbUrl} noButton />
                </Col>
              </Row>
            </Container>
          </SectionCL>
        )}
        <SectionCL
          id=""
          color="black"
          className="text-center text-white"
          angle={videoControl === 'v1' ? 'both' : 'bottom'}
        >
          <Container>
            <Row>
              <Col>
                <h3 className="section-only-heading text-400">
                  In This <b>90-Minute Masterclass,</b> We’ll Reveal:
                </h3>
              </Col>
            </Row>
          </Container>
        </SectionCL>
        <SectionCL id="" color="white">
          <Container>
            <Row>
              <Col>
                <IconListCL iconColor="black" iconAlignment="start" className="m-0">
                  <>
                    <h5 className="section-heading mb-1 text-black">
                      {variant === 'ad' ? (
                        <>
                          Get the latest updates about what <i>NEVER</i> to eat.
                        </>
                      ) : (
                        <>
                          Discover what <i>NEVER</i> to eat if you want to prevent diabetes and prediabetes.
                        </>
                      )}
                    </h5>
                    <p>
                      {variant === 'ad' ? (
                        <>(And why carbs aren’t as bad as they’re made out to be.)</>
                      ) : (
                        <>(And why carbs aren’t the villain they’re made out to be.)</>
                      )}
                    </p>
                  </>
                  <>
                    <h5 className="section-heading mb-1 text-black">
                      {variant === 'ad' ? (
                        <>Find out why the conventional approach can cause the disease to get WORSE —</>
                      ) : (
                        <>Find out why the conventional approach to diabetes can cause it to get WORSE —</>
                      )}
                    </h5>
                    <p>
                      {variant === 'ad' ? (
                        <>and lead to weight gain and added complications.</>
                      ) : (
                        <>
                          and how to fix the real ROOT cause. (Thousands have gotten out of the danger zone this way.)
                        </>
                      )}
                    </p>
                  </>
                  <>
                    <h5 className="section-heading mb-1 text-black">
                      {variant === 'ad' ? (
                        <>
                          Learn a simple reframe to lose weight and slash risk by eating <i>more</i> food.
                        </>
                      ) : (
                        <>
                          Learn a simple reframe to lose weight and slash diabetes risk by eating <i>more</i> food.
                        </>
                      )}
                    </h5>
                    <p>
                      {variant === 'ad' ? (
                        <>This simple change can reset metabolism permanently.</>
                      ) : (
                        <>This simple switch can reset your metabolism to burn fat while you sleep.</>
                      )}
                    </p>
                  </>
                  <>
                    <h5 className="section-heading mb-1 text-black">
                      {variant === 'ad' ? (
                        <>Debunk the widely-held myth about getting enough protein</>
                      ) : (
                        <>Debunk the widely-held myth about eating enough protein</>
                      )}
                    </h5>
                    <p>
                      {variant === 'ad' ? (
                        <>that can cause an INCREASE in risk.</>
                      ) : (
                        <>that can cause an INCREASE in diabetes risk.</>
                      )}
                    </p>
                  </>
                  <>
                    <h5 className="section-heading mb-1 text-black">
                      Discover the single most important thing to do after a meal to prevent diabetes.
                    </h5>
                    <p>
                      {variant === 'ad' ? (
                        <>(This works, especially if it’s been hard to exercise lately.)</>
                      ) : (
                        <>(This works, especially if you’ve had a hard time exercising lately.)</>
                      )}
                    </p>
                  </>
                  <>
                    <h5 className="section-heading mb-1 text-black">
                      Demystify terms like blood sugar and insulin resistance,
                    </h5>
                    <p>
                      and get straight talk that’s easy to understand. (Most doctors don’t have time to explain this.)
                    </p>
                  </>
                  <>
                    <h5 className="section-heading mb-1 text-black">
                      {variant === 'ad' ? (
                        <>Understand why no one can afford to ignore diabetes:</>
                      ) : (
                        <>
                          Understand why you can’t afford to ignore diabetes — even if you haven’t been diagnosed yet:
                        </>
                      )}
                    </h5>
                    <p>
                      {variant === 'ad' ? (
                        <>
                          Stop surrendering to a life riddled with fatigue, extra weight (especially around the belly),
                          and failed attempts at eating differently. These simple steps will change EVERYTHING.
                        </>
                      ) : (
                        <>
                          Stop surrendering to a life riddled with pain, fatigue, extra weight (including the most
                          dangerous kind around the belly), and failed attempts at changing your diet — while slashing
                          your risk of complications like heart disease, stroke, blindness, amputation, and early death.
                        </>
                      )}
                    </p>
                  </>
                </IconListCL>
              </Col>
            </Row>
          </Container>
        </SectionCL>
        <SectionCL id="" color="black" className="text-center text-white">
          <Container>
            <Row>
              <Col>
                <h3 className="section-only-heading">Meet Your Instructor</h3>
              </Col>
            </Row>
          </Container>
        </SectionCL>
        <SectionCL
          id=""
          // @ts-ignore
          imgUrl={require('static/speaker/brenda-headshot.jpg')}
          imgPosition="right"
          color="white"
        >
          <Container>
            <Row>
              <Col>
                <h2 className="section-heading mb-2">Brenda Davis, RD</h2>
                <h4 className="mt-0 text-400">
                  Brenda Davis, RD, is a registered dietitian, a respected researcher, and an internationally acclaimed
                  speaker.
                </h4>
                <p>
                  Brenda Davis, RD, is a registered dietitian, a respected researcher, and an internationally acclaimed
                  speaker. She is the author/co-author of 12 books with nearly a million copies in print and in 15
                  languages.
                </p>
                <p>
                  Her most recent works include <i>Kick Diabetes Essentials</i> and <i>The Kick Diabetes Cookbook</i>{' '}
                  (with Vesanto Melina). Brenda is also co-author of numerous peer-reviewed journal articles and the
                  lead dietitian for the Diabetes Wellness Project in the Marshall Islands.
                </p>
              </Col>
            </Row>
          </Container>
        </SectionCL>
        <SectionCL id="" color="light-gray" innerClass="mobile-padding">
          <Container>
            <Row>
              <Col>
                <h4 className="section-heading text-center mb-5">
                  Here’s what some of the world’s leading figures have said about Brenda Davis, MD
                </h4>
                <TestimonialBubble id="tt2-michael-greger" bgColor="white" className="mb-5" />
                <TestimonialBubble id="tt2-neal-barnard" bgColor="white" className="mb-5" />
                <TestimonialBubble id="tt2-scott-stoll" bgColor="white" className="mb-5" />
                <TestimonialBubble id="tt2-michael-klaper" bgColor="white" className="mb-5" />
                <TestimonialBubble id="tt2-julieanna-hever" bgColor="white" />
              </Col>
            </Row>
          </Container>
        </SectionCL>
        <SectionCL id="" color="black" className="text-center text-white">
          <Container>
            <Row>
              <Col>
                <h3 className="section-only-heading">Meet Your Host</h3>
              </Col>
            </Row>
          </Container>
        </SectionCL>
        <SectionCL
          id=""
          imgUrl="https://cdn.foodrevolution.org/global/team/frn-guest_expert-portrait-square-ocean_robbins.jpg"
          imgPosition="left"
          color="white"
        >
          <Container>
            <Row>
              <Col>
                <h2 className="section-heading mb-2">Ocean Robbins</h2>
                <h4 className="mt-0 text-400">A food revolution leader and inspiration to millions.</h4>
                <p>
                  Ocean Robbins, co-founder and CEO of the million-member Food Revolution Network, is a TEDx speaker,
                  best-selling author, husband, father, gardener, and dancer. Born in a log cabin and raised on
                  home-grown food, his work is rooted in his family’s health-conscious legacy. From founding the
                  nonprofit YES! at age 16 to leading a global food revolution movement, Ocean is on a mission to
                  transform our food system, drive down the chronic disease epidemic, and mobilize people worldwide to
                  be part of the solution for a healthier planet and population. His books include{' '}
                  <i>31-Day Food Revolution</i> and <i>Powered By Plants.</i>
                </p>
              </Col>
            </Row>
          </Container>
        </SectionCL>
        <SectionCL id="" color="light-gray" angle="none" order="last" innerClass="text-center">
          <Container>
            <Row>
              <Col>
                <div className="background-white p-4 p-lg-5 rounded box-shadow-black-50">
                  <h2 className="section-heading text-purple mb-2">
                    <i>Don’t Miss Your Chance!</i>
                  </h2>
                  <h3 className="m-0">For a limited time watch the</h3>
                  <Logo className="my-4" />
                  <h4 className="text-purple my-4">
                    <i>It’s Completely Free.</i>
                  </h4>
                  <div>
                    <ModalTrigger className="mb-0" />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </SectionCL>
      </div>

      <div className="footer-content mt-auto">
        <Footer adVariant={variant === 'ad' ? true : false} />
      </div>

      <OptinModal variant={variant} />

      {!noExitIntent && (
        <ExitModal
          exitDelay={30000}
          content={
            <>
              <h4 className="section-heading mb-4">Before you press X…</h4>
              <p>Will your next meal have the diabetes-busting nutrients you need to protect yourself?</p>
              <p>
                <b>Join the Tackling Type 2 Masterclass</b>
              </p>
            </>
          }
          image={{
            url: require('static/backgrounds/1216786444-exit.jpg'),
            alt: '',
            width: 1200,
            height: 960
          }}
          positiveOptin
          positiveButtonText="Yes, I want to protect my health"
          positiveButtonColor="exit-orange"
          negativeButtonText="No thanks, I’ll take my chances"
        />
      )}
    </div>
  );
}
